<script setup lang="ts">
import TableLibrary from './TableLibrary/index.vue'
import { TooltipProvider } from '@/components/ui/tooltip'
import type { Elemental } from '~~/src/types/elemental'
const props = defineProps<{
  separatedByType?: boolean
  hideFilters?: boolean
  hideTableHeader?: boolean
  elementals?: Elemental[]
  filterByMe?: boolean
}>()
const separatedByType = computed(() => props.separatedByType ?? false)
</script>

<template>
  <div class="wrapper-table">
    <slot name="recent-elementals" />
    <TooltipProvider>
      <TableLibrary
        :separated-by-type="separatedByType"
        :hide-filters="hideFilters"
        :elementals="elementals"
        :hide-table-header="hideTableHeader"
        :filter-by-me="filterByMe"
      />
    </TooltipProvider>
  </div>
</template>
